import React, { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext();
const LANGUAGE_STORAGE_KEY = "selectedLanguage";

export const I18nProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => localStorage.getItem(LANGUAGE_STORAGE_KEY) || "en");
  const [translations, setTranslations] = useState({});

  const setLanguage = (value) => {
    setLanguageState(value);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, value);
  };

  useEffect(() => {
    const load = async () => {
      try {
        const module = await import(`./languages/${language}/index.js`);
        setTranslations(module.default);
      } catch {
        const module = await import("./languages/en/index.js");
        localStorage.setItem(LANGUAGE_STORAGE_KEY, "en");
        setLanguageState("en");
        setTranslations(module.default);
      }
    };

    load();
  }, [language]);

  return (
    <I18nContext.Provider value={{ translations, setLanguage ,language}}>
      {children}
    </I18nContext.Provider>
  );
};

export const useTranslation = () => useContext(I18nContext);
